import type { AvailableControls } from '../../types';
import {
  ImageControl,
  LatexControl,
  BetaControl,
  SdControl,
  SummationControl,
  AlignCenterControl,
  AlignLeftControl,
  AlignRightControl,
  BoldControl,
  ItalicControl,
  StrikethroughControl,
  UnderlineControl,
  SubscriptControl,
  SuperscriptControl,
  BulletListControl,
  NumberListControl,
  ClearFormattingControl,
  H1Control,
  H2Control,
  H3Control,
  TableControl,
  UndoControl,
  RedoControl,
} from '../rich-text-editor-control';

export const CONTROLS: Record<AvailableControls, () => JSX.Element> = {
  latex: LatexControl,
  beta: BetaControl,
  sd: SdControl,
  summation: SummationControl,
  image: ImageControl,
  table: TableControl,
  h1: H1Control,
  h2: H2Control,
  h3: H3Control,
  bold: BoldControl,
  italic: ItalicControl,
  underline: UnderlineControl,
  strikethrough: StrikethroughControl,
  subscript: SubscriptControl,
  superscript: SuperscriptControl,
  clearFormatting: ClearFormattingControl,
  alignCenter: AlignCenterControl,
  alignLeft: AlignLeftControl,
  alignRight: AlignRightControl,
  bulletList: BulletListControl,
  numberList: NumberListControl,
  undo: UndoControl,
  redo: RedoControl,
} as const;
